<div *ngIf="loggedIn">
  <app-banner></app-banner>
  <app-devices></app-devices>
</div>
